import { render, staticRenderFns } from "./QASessionBtn.vue?vue&type=template&id=47e57922&"
import script from "./QASessionBtn.vue?vue&type=script&lang=js&"
export * from "./QASessionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports